import daysBetween from '../daysBetween';

import { Dateable } from '../types';

export const daysFromNow = (dateTime: Dateable): number =>
  Math.abs(daysBetween(Date.now(), dateTime));

export default daysFromNow;
